<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.quotations'), $t('text.list') + '：' + customerName]"
      >
        <router-link
          v-if="Permit.canActionsChargeEdition('quoteToCustomerManage')"
          :to="{ name: 'pdmQuotationsNew', params: { id: customerId } }"
        >
          <el-button type="success" size="mini"
            >+ {{ $t("text.create") }}</el-button
          >
        </router-link>
      </breadcrumb>
    </div>

    <div class="search">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        v-if="Permit.canActionsChargeEdition('quoteToCustomerManage')"
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-checkbox
              v-model="checkAllDF"
              value="1"
              style="margin-right: 10px"
              @change="checkAll"
              >{{ $t("action.checkAll") }}</el-checkbox
            >

            <el-button
              type="danger"
              size="mini"
              :loading="batchDeleteDoing"
              @click="deleteBatch"
              >{{ $t("text.delete") }}</el-button
            >
          </template>
        </vxe-toolbar>
      </sticky>
      <div :loading="loading">
        <div v-if="records && records.length != 0">
          <el-row :gutter="5">
            <el-col
              v-for="(row, rowIndex) in records"
              :key="row.id"
              :span="4"
              class="mgt10"
            >
              <el-card :body-style="{ padding: '0px' }">
                <div style="height: 280px">
                  <div class="image-div">
                    <div
                      v-if="
                        Permit.canActionsChargeEdition('quoteToCustomerManage')
                      "
                      class="product-checkbox-div"
                      style="z-index: 2"
                    >
                      <input
                        v-model="checkedProducts"
                        type="checkbox"
                        :value="row"
                        class="float-right"
                        @change="checkedProduct"
                      />
                    </div>
                    <thumbnail
                      :images="row.product.images"
                      width="100%"
                      height="auto"
                    />
                  </div>
                  <div class="pd2">
                    <el-row class="mgb5">
                      <el-col :span="14" class="overflow">
                        <span
                          v-if="
                            Permit.extendModels().includes('wms') &&
                            row.hasInv == true
                          "
                          class="orange"
                          >(库)</span
                        >
                        {{ row.product.productNo }}
                      </el-col>
                      <el-col :span="10" class="overflow right">
                        <small>{{
                          (row.product.salesPrice || 0) | currency
                        }}</small>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12" class="overflow">
                        <div style="min-height: 10px">
                          {{ row.product.categoryName }}&nbsp;
                        </div>
                      </el-col>
                      <el-col :span="12" class="overflow right red">
                        <el-popover
                          v-if="row.quotationSizePrices.length != 0"
                          placement="right"
                          width="200"
                          trigger="click"
                        >
                          <div
                            v-for="quotationSizePrice of row.quotationSizePrices"
                            :key="quotationSizePrice.id"
                            class="font14"
                          >
                            {{ quotationSizePrice.size }}:{{
                              quotationSizePrice.price | currency
                            }}
                          </div>

                          <small slot="reference" class="popover-reference">{{
                            row.price | currency
                          }}</small>
                        </el-popover>
                        <span v-else>{{ row.price | currency }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="10">
                        <el-button
                          v-if="
                            Permit.canActionsChargeEdition(
                              'quoteToCustomerManage'
                            )
                          "
                          size="mini"
                          type="text"
                          @click="editRow(row, rowIndex)"
                          >{{ $t("text.edit") }}</el-button
                        >
                        <el-button
                          v-if="
                            Permit.canActionsChargeEdition(
                              'quoteToCustomerManage'
                            )
                          "
                          type="text"
                          size="mini"
                          @click="deleteRow(row)"
                          >{{ $t("text.delete") }}</el-button
                        >
                      </el-col>
                      <el-col :span="14" class="right overflow">
                        <div
                          v-if="
                            row.price != null &&
                            row.price != 0 &&
                            row.product.salesPrice != null &&
                            row.product.salesPrice != 0
                          "
                          style="padding-top: 4px"
                        >
                          {{ $t("quotation.discountRate") }}:{{
                            Util.toFixed(
                              (row.price / row.product.salesPrice) * 100,
                              2
                            )
                          }}%
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <div v-else class="noData">{{ $t("text.noData") }}</div>
      </div>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>

      <!-- 编辑报价 -->
      <el-dialog
        :append-to-body="true"
        :title="$t('rules.edit', [$t('product.quotation')])"
        :close-on-click-modal="false"
        :visible.sync="editProductQuotationDF"
        width="30%"
      >
        <el-form
          ref="editProductQuotationObjForm"
          :model="editProductQuotationObj"
          label-width="70px"
        >
          <el-form-item
            :label="$t('quotation.price')"
            :prop="'price'"
            :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('quotation.price')]),
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              size="small"
              v-model.trim="editProductQuotationObj.price"
            />
          </el-form-item>
          <el-form-item
            v-if="Permit.extendModels().includes('wms')"
            :label="$t('quotation.hasInv')"
            :prop="'hasInv'"
          >
            <el-checkbox
              size="small"
              v-model="editProductQuotationObj.hasInv"
            />
          </el-form-item>
          <div v-if="editProductQuotationObj.quotationSizePrices.length != 0">
            <el-form-item
              :prop="'productNo'"
              :label="$t('quotation.sizePrice')"
            >
              <el-row>
                <el-col
                  v-for="(
                    quotationSizePrice, index
                  ) in editProductQuotationObj.quotationSizePrices"
                  :key="index"
                  :span="12"
                >
                  <el-input
                    size="small"
                    v-model.trim="quotationSizePrice.price"
                  >
                    <template slot="prepend">
                      <div>
                        <raw-html-limit-number
                          :content="quotationSizePrice.size"
                          :number="6"
                        />
                      </div>
                    </template>
                  </el-input>
                </el-col>
              </el-row>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            plain
            :loading="editProductQuotationDoing"
            size="small"
            @click="editProductQuotationSubmit"
            >{{ $t("text.submit") }}</el-button
          >
          <el-button size="small" @click="editProductQuotationDF = false">{{
            $t("text.close")
          }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import PagerConfig from "@/config/pager.js";
import Thumbnail from "@/components/Thumbnail";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Quotation from "@/api/quotation.js";

export default {
  mixins: [page, table.pager, table.search, table.checker, table.basic],
  components: {
    Thumbnail,
    RawHtmlLimitNumber,
  },
  data() {
    return {
      Util: Util,
      pagerConfig: PagerConfig.product,
      pager: {
        currentPage: 1,
        pageSize: PagerConfig.product.defaultPageSize,
        total: 0,
      },
      // initFilter: "yes",
      searchForm: {
        productNo: null,
      },
      sorter: {
        sortBy: "quotations_id",
        sortIndicator: "desc",
      },
      Util: Util,
      checkedProducts: [],
      checkAllDF: false,
      customerName: null,
      customerId: null,
      //
      // 编辑
      editProductQuotationDF: false,
      editProductQuotationObj: {
        price: null,
        hasInv: false,
        quotationSizePrices: [],
      },
      editProductQuotationDoing: false,
      //
      batchDeleteDoing: false,
    };
  },
  computed: {
    implicit() {
      return {
        customerId: this.$route.params.id,
      };
    },
  },
  created() {
    this.customerId = this.$route.params.id;
    this.customerName = this.$route.query.customerName;
  },
  methods: {
    deleteBatch() {
      const self = this;
      if (self.checkedProducts.length === 0) {
        this.$message({
          message: self.$t("prompt.atLeastOneData"),
          type: "warning",
        });
        return;
      }
      const ids = self.checkedProducts.map((c) => c.id);
      self.batchDeleteDoing = true;
      Quotation.deleteByIds(ids).then(function (res) {
        self.batchDeleteDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.delSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },

    // 编辑
    editRow(row) {
      const self = this;
      self.row = row;
      self.editProductQuotationObj.price = row.price;
      self.editProductQuotationObj.hasInv = row.hasInv;
      if (self.row.product.sizes.length !== 0) {
        self.editProductQuotationObj.quotationSizePrices = self.row.product.sizes.map(
          (s) => {
            return {
              size: s,
              price:
                row.quotationSizePrices.find((sp) => sp.size === s) != null
                  ? row.quotationSizePrices.find((sp) => sp.size === s).price
                  : null,
            };
          }
        );
      } else {
        self.editProductQuotationObj.quotationSizePrices = [];
      }
      self.editProductQuotationDF = true;
      self.editProductQuotationDoing = false;
    },

    editProductQuotationSubmit() {
      const self = this;
      self.$refs.editProductQuotationObjForm.validate((valid) => {
        if (valid) {
          if (!Util.regexPrice(self.editProductQuotationObj.price)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("quotation.price")]),
              type: "warning",
            });
            return;
          }
          if (self.editProductQuotationObj.quotationSizePrices.length !== 0) {
            const quotationSizePricesFilter = self.editProductQuotationObj.quotationSizePrices.filter(
              (p) => p.price != null && p.price !== ""
            );
            if (quotationSizePricesFilter.length !== 0) {
              for (const f of quotationSizePricesFilter) {
                if (!Util.regexPrice(f.price)) {
                  self.$message({
                    message: self.$t("rules.regex", [
                      self.$t("quotation.sizePrice"),
                    ]),
                    type: "warning",
                  });
                  return;
                }
              }
            }
            self.editProductQuotationObj.quotationSizePrices = quotationSizePricesFilter;
          }
          self.editProductQuotationDoing = true;
          Quotation.update(self.row.id, self.editProductQuotationObj).then(
            function (res) {
              self.editProductQuotationDoing = false;
              self.editProductQuotationDF = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.editSuccess"),
                  type: "success",
                });
                self.loadData();
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Quotation.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },

    checkedProduct() {
      this.selectRecordQty = this.checkedProducts.length;
    },

    checkAll() {
      if (this.checkAllDF === true) {
        this.checkedProducts = this.records;
      } else {
        this.checkedProducts = [];
      }
      this.selectRecordQty = this.checkedProducts.length;
    },
    dataProvider(params) {
      return Quotation.quoterSearch(params);
    },
  },
};
</script>
<style scoped>
.image-div {
  height: 200px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
}
.product-checkbox-div {
  position: absolute;
  width: 16%;
}
.product-label-div {
  position: absolute;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
}
.product-label {
  background: #d83732;
  border: 1px solid #d83732;
  margin: 1px 0;
  text-align: left;
  padding: 2px 6px 2px 2px;
  font-size: 12px;
  display: inline-block !important;
  display: inline;
  border-bottom-right-radius: 40px;
  border-top-right-radius: 40px;
  color: #fff;
  opacity: 0.8;
  /* width: auto; */
  /* max-width: 60px; */
  /* overflow: hidden; */
}
</style>